let init = {
  show: false
}

export default (state = init, action) => {
  switch (action.type) {
    case 'TOGGLE_SIDEBAR_SHOW':
      return {...state, show: !state.show}
    case 'CLOSE_SIDEBAR_SHOW':
      return {...state, show: false}
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/reducer.js